export const dateTimeFormats = {
  short: {
    month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  medium: {
    year: 'numeric', month: 'short', day: 'numeric'
  },
  long: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  full: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
  }
};

export const messages = {
    "login.form.title": "Accesso",
    "login.form.hint.user": "Login",
    "login.form.hint.password": "Password",
    "login.form.checkbox.remember-me": "Ricorda",
    "login.form.button.sign-in": "Accedi",
    "login.form.message.invalid-user-credentials": "Login o password errati",
    "login.form.message.user-required": "Inserire un login",
    "login.form.message.password-required": "Inserire una password",
    "login.form.button.forgot-password": "Password dimenticata?",
    "error.root-admin-login.title": "Errore 403 – proibito",
    "error.root-admin-login.message": "Accesso eseguito come Amministratore di sola lettura. Per accedere alla console Web Recovery accedere come utente o amministratore del tenant cliente"
};
